import React from "react";
import type { FaqItem } from "../services/SiteSettings";

export function PageFaq({ faqs, title = "Frequently Asked Questions" }: { faqs: FaqItem[]; title?: string }) {
  const list = faqs.filter((f) => f.question.trim() && f.answer.trim());
  if (!list.length) return null;
  return (
    <section className="py-16 bg-gray-50" aria-labelledby="faq-heading">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 id="faq-heading" className="text-3xl font-bold text-gray-900 mb-8 text-center">
          {title}
        </h2>
        <div className="space-y-6">
          {list.map((f, i) => (
            <div key={i} className="bg-white rounded-lg p-6 shadow-sm">
              <h3 className="text-lg font-semibold text-gray-900 mb-2">{f.question}</h3>
              <p className="text-gray-700 leading-relaxed">{f.answer}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

// Renders plain text: blank-line separated paragraphs, "- " lines become bullets
export function TextBlocks({ text, className = "" }: { text: string; className?: string }) {
  const groups: { bullet: boolean; lines: string[]; closed?: boolean }[] = [];
  for (const block of (text || "").split(/\n\s*\n/)) {
    for (const raw of block.split("\n")) {
      const line = raw.trim();
      if (!line) continue;
      const bullet = line.startsWith("- ");
      const last = groups[groups.length - 1];
      if (last && last.bullet === bullet && !last.closed) last.lines.push(bullet ? line.slice(2) : line);
      else groups.push({ bullet, lines: [bullet ? line.slice(2) : line] });
    }
    if (groups.length) groups[groups.length - 1].closed = true;
  }
  return (
    <div className={`space-y-4 ${className}`}>
      {groups.map((g, i) =>
        g.bullet ? (
          <ul key={i} className="list-disc pl-6 space-y-1">
            {g.lines.map((l, j) => (
              <li key={j}>{l}</li>
            ))}
          </ul>
        ) : (
          <p key={i}>{g.lines.join(" ")}</p>
        )
      )}
    </div>
  );
}
